module.exports = "/_next/static/images/5c55a0f65309a8798b4bf6e5ca8447b6-hot-sale-hero-mobile.jpg";